import { useMemo } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useIsSplitTestSelector = (id: string) => {
  const state = useGetEditOrActual();

  return useMemo(() => !!state.splitTests[id], [id, state.splitTests]);
};
